import { render, staticRenderFns } from "./ups-downs-futures.vue?vue&type=template&id=0f9ade6b&scoped=true"
import script from "./ups-downs-futures.vue?vue&type=script&lang=js"
export * from "./ups-downs-futures.vue?vue&type=script&lang=js"
import style0 from "./ups-downs-futures.vue?vue&type=style&index=0&id=0f9ade6b&prod&lang=css"
import style1 from "./ups-downs-futures.vue?vue&type=style&index=1&id=0f9ade6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9ade6b",
  null
  
)

export default component.exports